import { NotFound } from "@/frontend/pages/NotFound";
import { ProjectReadyTaskList } from "./ProjectReadyTaskList";
import { useParams } from "react-router-dom";
import { useRequirementsStore } from "@/frontend/store/RequirementsStore";
import { useEffect } from "react";
import { I18n } from "@/i18n/I18n";

export function ProjectTasksPage() {
  const projectId = useParams().projectId;
  const fetchReadyTasks = useRequirementsStore(state => state.fetchReadyVerificationCriteriaTasksByProjectId);
  const tasks = useRequirementsStore(state => state.verificationCriteriaTasks);

  useEffect(() => {
    if (projectId) {
      void fetchReadyTasks(projectId);
    }
  }, [projectId, fetchReadyTasks]);

  if (!projectId) {
    return <NotFound />;
  }

  return (
    <div className="p-3">
      <h4 className="card-title pb-2">{I18n.get('tasks')}</h4>
      <ProjectReadyTaskList tasks={tasks} />
    </div>
  );
}
